module.exports = __webpack_public_path__ + "static/img-invisible-walker-7f3e9b0248855333f6248b3de53e0a55.jpg";